import React from 'react';
import arrowImage from 'assets/images/Arrow.png'

export const MiningFrontier = () => {
  return (
    <div className="mining-frontier">
      <h1>Charting Pakistan's Mining Frontier:</h1>
      <h2>Where Minerals Meet Opportunity</h2>
      <p>
        We work with partners and communities that help nature thrive and allow
        climate change to be preserved
      </p>
      <button className="view-projects-button">
        View Projects  &rarr;
      </button>
    </div>
  );
};